import React from 'react';
import Hero from 'components/hero';
import BenefitArticle from 'components/benefit-article';
import ImgTokens from 'svg/illustrations/undraw_dev_focus_b9xo.svg';
import ImgWorkers from 'svg/illustrations/undraw_performance_overview_p9bm.svg';
import './style.css';

const EmployerHow = () => {
  return (
    <Hero layout="vertical" className="employer-how">
      <h2>This is how it works:</h2>
      <BenefitArticle
        title="Health and Social Care providers can purchase ‘Connection Tokens’"
        image={ImgWorkers}
        isLeft
      >
        <div className="employer-how">
          <p>
            Health and Social Care providers can purchase ‘Connection Tokens’
            which they can manage centrally or share amongst other Homes or
            Divisions in their group. The workers database is free to search and
            will provide the following information about an individual worker:
          </p>
          <ol>
            <li>
              <p>
                Their matching skills and qualifications to your requirements
              </p>
            </li>
            <li>
              <p>Distance they have to travel to your site</p>
            </li>
            <li>
              <p>Hourly pay rate expectations</p>
            </li>
          </ol>
        </div>
      </BenefitArticle>
      <BenefitArticle
        title="To view all their full profile, connect with them, send a message and engage with a worker requires the use of tokens."
        image={ImgTokens}
      >
        <p>
          The Token cost is £10.00 plus vat per token.
          <br />
          Tokens can be purchased individually at a cost of £10.00 plus VAT
          <br />
          Bundles of Tokens can be purchased at discounted rates:
          <br />
          Bronze Bundle: 10 tokens - £95:00 plus VAT (5% discount)
          <br />
          Silver Bundle: 25 tokens = £225:00 plus VAT (10% discount)
        </p>
      </BenefitArticle>
    </Hero>
  );
};

export default EmployerHow;
